import axiosHttp from "services/axiosHttp";
const { createAsyncThunk, createSlice } = require("@reduxjs/toolkit");

export const fetchPettyCashRequestSummary = createAsyncThunk("fetchPettyCashRequestSummary", async ({ department, uuid } = {}, { rejectWithValue }) => {
	try {
		const params = new URLSearchParams({
			department: department ?? "",
			uuid: uuid ?? "",
		});
		const response = await axiosHttp.get(`petty-cash/summary/requests?${params}`);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const PettyCashRequestSummarySlice = createSlice({
	name: "PettyCashRequestSummarySlice",
	initialState: {
		isLoading: false,
		isError: false,
		error: null,
		data: null,
	},
	reducers: {
		resetPettyCashRequestSummaryState: (state) => {
			state.isLoading = false;
			state.isError = false;
			state.error = null;
			state.data = null;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchPettyCashRequestSummary.pending, (state) => {
			state.isLoading = true;
			state.isError = false;
			state.error = null;
		});

		builder.addCase(fetchPettyCashRequestSummary.fulfilled, (state, action) => {
			state.isLoading = false;
			state.isError = false;
			state.data = action.payload;
		});

		builder.addCase(fetchPettyCashRequestSummary.rejected, (state, action) => {
			state.isLoading = false;
			state.isError = true;
			state.error = action.payload || action.error;
		});
	},
});

export const { resetPettyCashRequestSummaryState } = PettyCashRequestSummarySlice.actions;
export default PettyCashRequestSummarySlice.reducer;
